import { type FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";
import { CarLoadingAnimation } from "../atoms/animations/CarLoadingAnimation";

interface DayPickerLoadingOverlayProps {
  showText?: boolean;
}

export const DayPickerLoadingOverlay: FunctionComponent<DayPickerLoadingOverlayProps> = ({
  showText = true,
}: DayPickerLoadingOverlayProps) => {
  const { t } = useTranslation();
  const messages = t("molecules.common.dayPicker.loadingState.messages", {
    returnObjects: true,
  }) as string[];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="absolute top-0 text-2xl font-serif w-full text-center bg-white opacity-90 h-full">
      <div className="h-1/2">
        <CarLoadingAnimation />
      </div>
      {showText && (
        <div className="p-4">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -100, opacity: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="whitespace-pre-line"
            >
              {messages[index]}
            </motion.div>
          </AnimatePresence>
        </div>
      )}
    </div>
  );
};
